import React from 'react';
import { useRecoilState } from 'recoil';
import { isLoadingState } from 'src/recoil';

function Home() {
  const [, setIsLoading] = useRecoilState(isLoadingState);

  return (
    <>
      <main style={{ textAlign: 'center' }}>
        <h2>Welcome to Business Care Portal</h2>
        <p onClick={() => {setIsLoading(true)}}>Please enter your collection address.</p>
      </main>
    </>
  );
}

export default Home;